export default {
    brand: [{
            name: '哈根达斯',
            img: 'static/dev/b2.jpeg',
            person: ['TA: 18-25 Young people', '2,537,000'],
            area: [
                [12, 483, 32],
                [780, 280, 51],
                [3900000, 4200000, 5100000]
            ],
            link: [
                'https://geohey.com/apps/dataviz/071abe720e9c418786291550ff55a4c4/share?ak=Njc3NjIyOTM5YzM1NGFlZmFhMDhmZjgxMDI4NzY0ZGI',
                'https://geohey.com/apps/dataviz/a4cab105ad894903b63650679325aa4c/share?ak=Njc3NjIyOTM5YzM1NGFlZmFhMDhmZjgxMDI4NzY0ZGI',
                'https://geohey.com/apps/dataviz/93ab436c4b4747eeb9a763d2c0c0dead/share?ak=Njc3NjIyOTM5YzM1NGFlZmFhMDhmZjgxMDI4NzY0ZGI',
                'https://geohey.com/apps/dataviz/8fe4eb46ca8d4e23aca1dae5e7322f77/share?ak=Njc3NjIyOTM5YzM1NGFlZmFhMDhmZjgxMDI4NzY0ZGI'
            ]
        }, {
            name: '资生堂',
            img: 'static/dev/b1.jpeg',
            person: ['TA: 18-30 female', '2,299,000'],
            area: [
                [11, 501, 35],
                [702, 225, 44],
                [3510000, 3375000, 4400000]
            ],
            link: [
                'https://geohey.com/apps/dataviz/c9d75804266e4e5596df2a22ad214e6a/share?ak=Njc3NjIyOTM5YzM1NGFlZmFhMDhmZjgxMDI4NzY0ZGI',
                'https://geohey.com/apps/dataviz/cf60627725964f188ca1066a7264adc5/share?ak=Njc3NjIyOTM5YzM1NGFlZmFhMDhmZjgxMDI4NzY0ZGI',
                'https://geohey.com/apps/dataviz/db704c0bd0514531991ada3f7705f3f7/share?ak=Njc3NjIyOTM5YzM1NGFlZmFhMDhmZjgxMDI4NzY0ZGI',
                'https://geohey.com/apps/dataviz/bc3b873cc49d4c18af5b826d233da993/share?ak=Njc3NjIyOTM5YzM1NGFlZmFhMDhmZjgxMDI4NzY0ZGI'
            ]
        }, {
            name: '花王',
            img: 'static/dev/b3.jpeg',
            person: ['TA: 18-40 female', '3,757,000'],
            area: [
                [14, 446, 38],
                [815, 252, 56],
                [4075000, 3780000, 5600000]
            ],
            link: [
                'https://geohey.com/apps/dataviz/ee1a7426e8744cfe947defb3c10356ed/share?ak=Njc3NjIyOTM5YzM1NGFlZmFhMDhmZjgxMDI4NzY0ZGI',
                'https://geohey.com/apps/dataviz/992a737a02dc43329d255ad672243bed/share?ak=Njc3NjIyOTM5YzM1NGFlZmFhMDhmZjgxMDI4NzY0ZGI',
                'https://geohey.com/apps/dataviz/d477a42f24f94ba9b846408c72fef7d6/share?ak=Njc3NjIyOTM5YzM1NGFlZmFhMDhmZjgxMDI4NzY0ZGI',
                'https://geohey.com/apps/dataviz/13d9e0235a36451db27caf2c4ce21dd9/share?ak=Njc3NjIyOTM5YzM1NGFlZmFhMDhmZjgxMDI4NzY0ZGI'
            ]
        },

    ]
}


// WEBPACK FOOTER //
// ./src/assets/link.js